import styled, { css } from "styled-components";
import { Tooltip } from "../../components";

export const StyledContainer = styled(Tooltip)<{
  $closed?: boolean;
}>`
  --radius: 0.25rem;
  --inset: -0.125rem;
  position: relative;
  display: inline-flex;
  flex-direction: row-reverse;
  align-items: center;
  border-radius: var(--radius);
  background-color: transparent;
  transition: all 0.3s ease;
`;

export const StyledWrapper = styled.div`
  position: relative;
  width: 5.6rem;
  height: 0.5rem;
  background: #F4F4F4;
  border-radius: 1rem;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  overflow: hidden;
  padding: 1.5rem 1rem;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease;

  ${StyledContainer}:hover & {
    opacity: 1;
    visibility: visible;
  }
`;

export const StyledWidget = styled.div`
  max-width: 45rem;
  width: 100%;
  display: inline-flex;
  justify-content: end;
  --main-color: #EFEEF1;
  position: relative;
`;

export const StyledChat = styled.div`
  position: relative;

  width: 100%;
  height: 90dvh;

  @media screen and (min-width: 48em) {
    height: auto;
  }
`;

export const StyledLinksWrapper = styled.div<{
  $closed?: boolean;
}>`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  transition: all 0.3s ease;
  width: auto;
  opacity: 1;
  position: relative;

  & > [data-tooltip] {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.125rem;
    color: #000;
    text-decoration: none;

    &:hover::after {
      content: attr(data-tooltip);
      color: #000;
      font-size: 0.65rem;
      white-space: nowrap;
    }
  }

  ${({ $closed }) =>
    $closed &&
    css`
      width: 0;
      margin-right: 0;
      opacity: 0;
      padding: 0;
      height: 0;
      overflow: hidden;
    `}
`;

export const StyledIcon = styled.a`
  --size: 2rem;
  font-family: system-ui, sans-serif;
  width: var(--size);
  height: var(--size);
  font-size: var(--size);
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  transition: all 0.3s ease;

  .anticon {
    font-size: 2rem;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

export const StyledFloatButton = styled.button`
  background-color: transparent;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius);
  border: 0;
  padding: 0;
  margin: 0.5rem;
  color: transparent;
  flex-shrink: 0;
  z-index: 9999;
  cursor: pointer;
  font-size: 2rem;
  transition: all 0.3s ease;
  overflow: hidden;
  transition: all 0.3s ease;

  .anticon {
    margin: 0.5rem;
    font-size: 4rem;
  }

  &:hover {
    transform: scale(1.1);
  }

  img {
    width: 4.375rem;
    height: 4.375rem;
  }
`;

export const StyledChatButton = styled.button`
  display: flex;
  justify-content: center;
  width: 6rem;
  height: 3.5rem;
  color: black;
  padding: 0;
  font-size: 1rem;
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: transparent;
  transition: all 0.3s ease;
`;
